<template>
  <div>
    <loader v-if="loading === true"></loader>
    <fetch-error
      v-else-if="customers instanceof FetchError"
      @retry="fetchData()"
      :error="customers"
    ></fetch-error>
    <template v-else>
      <div class="row">
        <p class="customer">
          تعداد کل مشتریان باشگاه:
          {{ customers.length }}
          نفر
        </p>
        <download-excel
          class="btn btn-default"
          :data="json_data"
          :fields="json_fields"
          worksheet="My Worksheet"
          :name="excelFileName"
        >
          <vs-button>دریافت اکسل</vs-button>
        </download-excel>
      </div>
      <vs-row vs-type="flex" vs-justify="flex-start">
        <vs-col
          v-for="(customer, index) in customers"
          :key="index"
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-sm="4"
          vs-lg="3"
          vs-xs="12"
          class="user-cont"
        >
          <img
            class="avatar"
            :src="customer.avatar.url || placeholder"
            :alt="customer.name"
          />
          <div>
            <p v-if="customer.name" class="name">
              {{ customer.name }}
            </p>
            <p class="phone">
              {{ customer.phone }}
            </p>
          </div>
        </vs-col>
      </vs-row>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import user_placeholder from "../../assets/images/user-placeholder.jpg";
import ProviderApiService from "../../services/api/ProviderApiService";
import FetchError from "./../../services/api/FetchError";

export default {
  data() {
    return {
      customers: [],
      loading: true,
      FetchError,
      placeholder: user_placeholder,
      json_fields: {
        "نام و نام خانوادگی کاربر": "name",
        "شماره همراه": "phone",
      },
      json_data: [],
      excelFileName: "",
    };
  },
  computed: mapGetters({
    currentProvider: "profile/currentProvider",
  }),
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      ProviderApiService.getCustomersClub(this.currentProvider.id)
        .then((res) => {
          this.customers = res.data;
          this.loading = false;
          this.json_data = res.data.map((item) => {
            return {
              name: item.name,
              phone: item.phone,
            };
          });
          this.excelFileName =
            "لیست مشتریان مجموعه " + this.currentProvider.name + ".xls";
        })
        .catch((err) => (this.customers = err));
    },
  },
};
</script>

<style scoped lang="scss">
.user-cont {
  background-color: #ffffff;
  height: 80px;
  margin: 0 15px;
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  box-shadow: 0px 0px 10px 1px rgba(var(--vs-primary), 0.15);
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.avatar {
  display: block;
  width: 50px;
  height: 50px;
  object-fit: cover;
  object-position: center;
  border-radius: 50%;
  border: 1px solid gray;
  padding: 1px;
  margin-right: 10px;
}

.customer,
.phone,
.name {
  font-size: 15px;
  color: #000000;
  display: block;
}

.phone {
  font-size: 14px;
}

.name {
  font-size: 17px;
  margin-bottom: 5px;
}
</style>
